var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-auto flex flex-col items-stretch overflow-hidden h-full"},[(_vm.rootPanel)?_c('Panel',{attrs:{"id":_vm.tab.root,"panel":_vm.rootPanel,"depth":0}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }